import BaseNotificationController from './baseNotification_controller'
import consumer from 'channels/consumer'

export default class extends BaseNotificationController {
  static targets = ['bell', 'dot', 'count', 'list']

  // ACTION CABLE INITIALISATION
  initialize() {
    const dataset = document.getElementById('notification-bell').dataset
    this.params = {
      channel: 'NotificationsChannel',
      notifications: parseInt(dataset.uid)
    }
    if(this._alreadySubscribed()) return

    consumer.subscriptions.create(this.params, {
      received: (notification) => {
        this._increaseCounter()
      }
    })
  }

  // private

  _alreadySubscribed() {
    if(!consumer) return(false)

    const identifiers   = consumer.subscriptions.subscriptions.map(s => s.identifier)
    const subscriptions = identifiers.map(identifier => JSON.parse(identifier))
    return subscriptions.find(s => s.channel == this.params.channel)
  }
}
